export interface SessionOnceGuard {
  has(id: string): boolean;
  mark(id: string, value?: string): void;
  read(id: string): string | null;
}

// Storage can be blocked (e.g. third-party storage in a cross-site embed), so
// marked values are also kept in memory for the life of the page.
export function createSessionOnceGuard(prefix: string): SessionOnceGuard {
  const markedValues = new Map<string, string>();

  function read(id: string): string | null {
    const marked = markedValues.get(id);
    if (marked !== undefined) return marked;

    try {
      return sessionStorage.getItem(`${prefix}${id}`);
    } catch {
      return null;
    }
  }

  return {
    has: (id) => read(id) !== null,
    mark(id, value = Date.now().toString()) {
      markedValues.set(id, value);
      try {
        sessionStorage.setItem(`${prefix}${id}`, value);
      } catch {}
    },
    read,
  };
}
